/* eslint-disable prefer-template */
/* eslint-disable no-var */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable arrow-body-style */
/* eslint-disable no-script-url */
/* eslint-disable react/button-has-type */
import React from 'react';
import { useLocation, useNavigate } from 'react-router';

const InvoicesDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const datas = location?.state;
  const currentUser = JSON.parse(localStorage.getItem('currentuser'));
  const arriveDateParts = datas?.booking?.arrive_date.split('-');
  const departDateParts = datas?.booking?.depart_date.split('-');
  const arriveDate = new Date(`20${arriveDateParts[0]}`, arriveDateParts[1] - 1, arriveDateParts[2]);
  const departDate = new Date(`20${departDateParts[0]}`, departDateParts[1] - 1, departDateParts[2]);
  const diffTime = Math.abs(departDate - arriveDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const nightlyRate = Number(datas?.listing?.nightly);
  const totalCost = diffDays * nightlyRate;

  function PrintElem() {
    var mywindow = window.open('', 'PRINT', 'height=400,width=600');

    mywindow.document.write('<html><head>');
    mywindow.document.write('</head><body >');
    mywindow.document.write(document.getElementById('elem').innerHTML);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }

  return (
    <>
      <main style={{ maxWidth: '100%', padding: '0 15px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: '0 0 66.666667%', maxWidth: '66.666667%' }} id='elem'>
            <div style={{ padding: '16px', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)', background: 'white' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
                <div style={{ flex: '0 0 auto', padding: '0px 16px' }}>
                  <div style={{ marginBottom: '8px' }}>
                    <img src={currentUser?.image} style={{ width: '200px' }} alt="logo" />
                  </div>
                  <ul style={{ padding: '0', listStyle: 'none' }}>
                    <li>
                      <strong>FlyInn LLC</strong>
                    </li>
                    <li>P.O. Box 270439, Fruitland, UT 84027</li>
                  </ul>
                </div>
                <div style={{ flex: '0 0 auto', padding: '0px 16px' }}>
                  <ul style={{ padding: '0', listStyle: 'none' }}>
                    <li style={{ display: 'flex', alignItems: 'baseline' }}>
                      <strong>Invoice:</strong>
                      <span>{datas?.invoice_number}</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'baseline' }}>
                      <strong>Date:</strong>
                      <span>{datas?.date}</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'baseline' }}>
                      <strong>Reservation ID:</strong>
                      <span>{datas?.reservation_id}</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'baseline' }}>
                      <strong>Check In:</strong>
                      <span>{datas?.booking?.arrive_date}</span>
                    </li>
                    <li style={{ display: 'flex', alignItems: 'baseline' }}>
                      <strong>Check Out:</strong>
                      <span>{datas?.booking?.depart_date}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div style={{ marginBottom: '16px', padding: '0px 16px' }}>
                <ul style={{ padding: '0', listStyle: 'none' }}>
                  <li>
                    <strong>To:</strong>
                  </li>
                  <li>- -</li>
                  <li>Email: - {datas?.user?.email}</li>
                </ul>
                <div style={{ padding: '0 16px' }}>
                  <li style={{ listStyle: 'none' }}>
                    <strong>Details</strong>
                  </li>
                  <hr />
                  <ul style={{ padding: '0', listStyle: 'none' }}>
                    <li className="sub-total" style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>
                        $ {datas?.listing?.nightly} x {diffDays}
                      </span>
                      <span>$ {totalCost}</span>
                    </li>
                    <hr />
                    <li className="sub-total" style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>Sub Total</span>
                      <span>$ {datas?.booking?.sub_total}</span>
                    </li>
                    <hr />
                    <li className="payment-due" style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>Total</span>
                      <span>$ {datas?.booking?.total}</span>
                    </li>
                  </ul>
                  <input type="hidden" name="is_valid_upfront_payment" id="is_valid_upfront_payment" value="4.56" />
                </div>
              </div>
            </div>
          </div>
          <div style={{ flex: '0 0 33.333333%', maxWidth: '33.333333%', padding: '0 16px' }}>
            <button
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 0',
                marginBottom: '8px',
                backgroundColor: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={PrintElem}
            >
              Print
            </button>
            <button
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 0',
                marginBottom: '8px',
                backgroundColor: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/dashboard/invoices')}
            >
              Go Back
            </button>
          </div>
        </div>
      </main>
    </>
  );
};

export default InvoicesDetails;
